module.exports = __webpack_public_path__ + "img/kasfqdcx.cf741711.png";